import api from './http';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// Assistance IA rédactionnelle (Gemini 3 Flash via backend)
// data: { text, action: 'improve'|'formal'|'fix'|'shorten'|'expand'|'custom', field?, custom_instruction? }
export const improveTextAI = (data) => api.post('/ai/improve-text', data);

// Résumé exécutif IA d'un dossier existant
export const generateDossierSummaryAI = (data) => api.post('/ai/dossier-summary', data);

// Assistant complet : {intention, type_dossier?, territoire?} → {objet, resume_executif, livrables[]}
export const generateFullDossierAI = (data) => api.post('/ai/dossier-full', data);
export const generateMissionTemplateAI = (intention) => api.post('/ai/mission-template', { intention });

// Recherche globale en langage naturel
export const searchAI = (question) => api.post('/search/ai', { question });
export const searchAIHistory = () => api.get('/search/ai/history');

// Bibliothèque de modèles de missions
export const listMissionTemplates = () => api.get('/mission-templates');
export const createMissionTemplate = (data) => api.post('/mission-templates', data);
export const updateMissionTemplate = (id, data) => api.patch(`/mission-templates/${id}`, data);
export const deleteMissionTemplate = (id) => api.delete(`/mission-templates/${id}`);

// Tour d'onboarding personnalisable
export const listTourSteps = () => api.get('/tour-steps');
export const listTourStepsAdmin = () => api.get('/tour-steps/admin');
export const createTourStep = (data) => api.post('/tour-steps', data);
export const updateTourStep = (id, data) => api.patch(`/tour-steps/${id}`, data);
export const deleteTourStep = (id) => api.delete(`/tour-steps/${id}`);
export const reorderTourSteps = (order) => api.patch('/tour-steps/reorder', { order });
export const completeTour = () => api.post('/tour-steps/complete');
export const listTourCompletions = () => api.get('/tour-steps/completions');
export const getTourProgress = () => api.get('/tour-steps/progress');
export const markTourStepDone = (step_id) => api.post('/tour-steps/progress', { step_id });

// Landing brouillon partageable
export const createLandingDraftShare = (snapshot) => api.post('/public/landing/draft-share', { snapshot });

// Recherches IA épinglées
export const listAIPins = () => api.get('/search/ai/pins');
export const pinAISearch = (data) => api.post('/search/ai/pins', data);
export const unpinAISearch = (id) => api.delete(`/search/ai/pins/${id}`);

// Landing A/B variantes
export const listLandingVariants = () => api.get('/landing/variants');
export const createLandingVariant = (data) => api.post('/landing/variants', data);
export const updateLandingVariant = (id, data) => api.patch(`/landing/variants/${id}`, data);
export const deleteLandingVariant = (id) => api.delete(`/landing/variants/${id}`);
export const trackLandingConversion = (variant_id, event) => api.post('/public/landing/track', { variant_id, event });
export const analyzeLandingAB = (auto_create = false) => api.post('/landing/variants/analyze-ai', { auto_create });

// Portail Ressources
export const listPortalResourcesPublic = () => api.get('/portal/resources');
export const listPortalResourcesAdmin = () => api.get('/portal-resources');
export const createPortalResource = (data) => api.post('/portal-resources', data);
export const updatePortalResource = (id, data) => api.patch(`/portal-resources/${id}`, data);
export const deletePortalResource = (id) => api.delete(`/portal-resources/${id}`);

export const getMyNotificationPrefs = () => api.get('/me/notification-prefs');
export const updateMyNotificationPrefs = (data) => api.patch('/me/notification-prefs', data);
export const previewMyDigest = (payload) => {
  // payload peut être une string (frequency) ou un objet {frequency, to}
  const body = typeof payload === 'string' ? { frequency: payload } : (payload || {});
  return api.post('/me/notification-prefs/preview-digest', body);
};
export const applyAutoTerritory = () => api.post('/me/notification-prefs/apply-auto-territory');
export const adminListNotificationPrefs = () => api.get('/admin/notification-prefs');
export const adminUpdateUserNotificationPrefs = (userId, data) => api.patch(`/admin/notification-prefs/${userId}`, data);
export const getTeamTourProgress = () => api.get('/tour-steps/team-progress');
export const getTeamTourProgressCsvUrl = () => `${API_URL}/api/tour-steps/team-progress.csv`;
export const getTourStepAnalytics = () => api.get('/tour-steps/step-analytics');
export const getTourStepAnalyticsHistory = (days = 30) => api.get(`/tour-steps/step-analytics-history?days=${days}`);
export const resetMyTourProgress = () => api.post('/tour-steps/reset');

// CMC batch actions
export const batchIssueAttestations = (ids) => api.post('/cmc/attestations-batch/issue', { ids });
export const batchRevokeAttestations = (ids, reason) => api.post('/cmc/attestations-batch/revoke', { ids, reason });
export const batchAttestPayments = (payment_ids, opts = {}) => api.post('/cmc/payments-batch/attest', { payment_ids, ...opts });
export const batchMarkPaidPayments = (payment_ids, opts = {}) => api.post('/cmc/payments-batch/mark-paid', { payment_ids, ...opts });
export const batchSetCooperatorsStatus = (ids, status) => api.post('/cmc/cooperators-batch/set-status', { ids, status });
export const batchSetUccStatus = (ids, status) => api.post('/cmc/ucc-batch/set-status', { ids, status });

// Adhesion : timeline admin d'un kit
export const getAdhesionKitTimeline = (id) => api.get(`/adhesion/kits/${id}/timeline`);
